/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'react-bootstrap';
import FormGroupInput from '../common/FormGroupInput'; // eslint-disable-next-line
import { copiriAxiosPost, copiriPortalRequest, copiriAxiosGet } from '../api/api'; // eslint-disable-next-line
import config from '../config/config'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import { genPageData } from '../langconfig/langconfig'; // eslint-disable-next-line
const AddEditProfileAddressModal = props => {
	// eslint-disable-next-line
	const { data, countriesData, inputField, setInputField, type, pageLanguageContent, itemData } = props;
	const [stateData, setStateData] = useState([]); // eslint-disable-next-line
	const [checkStateData, setCheckStateData] = useState(false);
	const [validation, setValidation] = useState({
		error_address_1: '',
		error_city: '',
		error_state: '',
		error_postal_code: '',
		error_country: ''
	});
	const [disableSubmitButton, setDisableSubmitButton] = useState(false);
	const [checkChangeData, setCheckChangeData] = useState({
		street_address_1: false,
		street_address_2: false,
		street_address_3: false,
		city: false,
		state: false,
		postal_code: false,
		facility_name: false,
		country: false
	});
	useEffect(() => {
		if (props.showHide) {
			getInputData();
			setValidation([]);
		}
		// eslint-disable-next-line
	}, [props.showHide]);

	function getInputData() {
		const { city, country, country_id, post_code, state_id, state } = itemData;
		setInputField({
			...inputField,
			city,
			country,
			country_id,
			post_code,
			state_id,
			state
		});
		if (country_id && country_id !== '') {
			getStatesData(country_id);
		}
	}
	const inputsHandler = (e, type = '') => {
		if (type === 'country') {
			getStatesData(e.target.value);
		}
		setInputField({ ...inputField, [e.target.name]: e.target.value });
		setCheckChangeData({ ...checkChangeData, [e.target.name]: true });
	};

	/* function to get the states Data based on country id */
	function getStatesData(country_id = 235, state_id) {
		var url = config.portal_url + '/?content_request=states&cid=' + country_id;
		copiriAxiosGet(url)
			.then(response => {
				if (response.data.length > 0) {
					setCheckStateData(true);
					setStateData(response.data);
				} else {
					setCheckStateData(false);
					setStateData([]);
				}
			})
			.catch(error => {});
	}

	function updateAddressData() {
		let errors = { ...validation };
		var errorCount = 0;

		if (!inputField.street_address_1) {
			errors.error_address_1 = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_address_1 = '';
		}

		if (!inputField.city) {
			errors.error_city = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_city = '';
		}

		if (!inputField.state) {
			errors.error_state = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_state = '';
		}

		if (!inputField.country) {
			errors.error_country = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_country = '';
		}

		if (!inputField.post_code) {
			errors.error_postal_code = pageLanguageContent['PRL026'];
			errorCount++;
		} else {
			errors.error_postal_code = '';
		}
		setValidation(errors);
		var sendFormData = {};

		if (checkChangeData['street_address_1']) {
			sendFormData['address_1'] = inputField['street_address_1'];
		}
		if (checkChangeData['street_address_2']) {
			sendFormData['address_2'] = inputField['street_address_2'];
		}
		if (checkChangeData['street_address_3']) {
			sendFormData['address_3'] = inputField['street_address_3'];
		}
		if (checkChangeData['city']) {
			sendFormData['city'] = inputField['city'];
		}
		if (checkChangeData['state']) {
			sendFormData['state_id'] = inputField['state'];
		}
		if (checkChangeData['postal_code']) {
			sendFormData['post_code'] = inputField['postal_code'];
		}
		if (checkChangeData['facility_name']) {
			sendFormData['facility'] = inputField['facility_name'];
		}
		sendFormData['country_id'] = inputField['country'];

		if (errorCount <= 0) {
			setDisableSubmitButton(true);
			copiriPortalRequest('/users/' + data['id'], config.app_version, 'patch', sendFormData)
				.then(response => {
					setDisableSubmitButton(false);
					if (response.status && response.status === 200) {
						toast.success(genPageData['GENDUS'] ? genPageData['GENDUS'] : '');
						props.onClick();
						props.updateModal(type, data['id'], inputField);
					}
				})
				.catch(error => {
					setDisableSubmitButton(false);
				});
		}
	}

	return (
		<>
			<Modal show={props.showHide} onHide={props.onClick}>
				<ModalHeader
					onHide={props.onClick}
					style={{ backgroundColor: '#337ab7', border: '#337ab7' }}
					className='modalHeader'
				>
					<Modal.Title>
						{type && type === 'edit_address'
							? pageLanguageContent['PRL155']
								? pageLanguageContent['PRL155']
								: ''
							: pageLanguageContent['PRL091']
							? pageLanguageContent['PRL091']
							: ''}
					</Modal.Title>
				</ModalHeader>
				<ModalBody>
					<Row>
						<Col lg={12}>
							<FormGroupInput
								id='facility_name'
								label={pageLanguageContent['PRL092'] ? pageLanguageContent['PRL092'] : ''}
								name='facility_name'
								type='text'
								onChange={inputsHandler}
								value={inputField.facility_name}
							/>
						</Col>

						<Col lg={12}>
							<FormGroupInput
								id='street_address_1'
								label={pageLanguageContent['PRL093'] ? pageLanguageContent['PRL093'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.street_address_1}
								name='street_address_1'
							/>
							{validation.error_address_1 && <p className='formValidationError'>{validation.error_address_1}</p>}
						</Col>

						<Col lg={6}>
							<FormGroupInput
								id='street_address_2'
								label={pageLanguageContent['PRL094'] ? pageLanguageContent['PRL094'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.street_address_2}
								name='street_address_2'
							/>
						</Col>

						<Col lg={6}>
							<FormGroupInput
								id='street_address_3'
								label={pageLanguageContent['PRL095'] ? pageLanguageContent['PRL095'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.street_address_3}
								name='street_address_3'
							/>
						</Col>

						<Col lg={6}>
							<FormGroupInput
								id='city'
								label={pageLanguageContent['PRL096'] ? pageLanguageContent['PRL096'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.city}
								name='city'
							/>
							{validation.error_city && <p className='formValidationError'>{validation.error_city}</p>}
						</Col>

						<Col lg={6}>
							<FormGroupInput
								id='postal_code'
								label={pageLanguageContent['PRL097'] ? pageLanguageContent['PRL097'] : ''}
								type='text'
								onChange={inputsHandler}
								value={inputField.post_code}
								name='post_code'
							/>
							{validation.error_postal_code && <p className='formValidationError'>{validation.error_postal_code}</p>}
						</Col>

						<Col lg={6}>
							<Form.Group className='form-group'>
								<Form.Label for='lodgeCountry'>
									{pageLanguageContent['PRL098'] ? pageLanguageContent['PRL098'] : ''}
								</Form.Label>
								<select
									id='country'
									label={pageLanguageContent['PRL098'] ? pageLanguageContent['PRL098'] : ''}
									type='text'
									onChange={e => inputsHandler(e, 'country')}
									value={inputField.country_id}
									name='country_id'
									className='form-control'
								>
									<option value=''>{pageLanguageContent['PRL100'] ? pageLanguageContent['PRL100'] : ''}</option>
									{countriesData.length > 0 &&
										countriesData.map((item, i) => (
											<option value={item.id} key={item.id}>
												{item.name}
											</option>
										))}
								</select>
							</Form.Group>
							{validation.error_country && <p className='formValidationError'>{validation.error_country}</p>}
						</Col>

						<Col lg={6}>
							<Form.Group className='form-group'>
								<Form.Label for='lodgeCountry'>
									{pageLanguageContent['PRL099'] ? pageLanguageContent['PRL099'] : ''}
								</Form.Label>
								{checkStateData ? (
									<select
										id='state'
										label={pageLanguageContent['PRL099'] ? pageLanguageContent['PRL099'] : ''}
										type='text'
										onChange={inputsHandler}
										value={inputField.state_id}
										name='state_id'
										className='form-control'
									>
										<option value=''>{pageLanguageContent['PRL100'] ? pageLanguageContent['PRL100'] : ''}</option>
										{stateData.length > 0 &&
											stateData.map((item, i) => (
												<option value={item.id} key={item.id}>
													{item.name}
												</option>
											))}
									</select>
								) : (
									<input
										type='text'
										name='state'
										id='state'
										placeholder=''
										onChange={inputsHandler}
										value={inputField.state}
										className='form-control'
									/>
								)}
							</Form.Group>
							{validation.error_state && <p className='formValidationError'>{validation.error_state}</p>}
						</Col>
					</Row>
				</ModalBody>
				<ModalFooter>
					<Button color='primary' onClick={updateAddressData} disabled={disableSubmitButton}>
						{genPageData['GENSAV'] ? genPageData['GENSAV'] : ''}
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};
export default AddEditProfileAddressModal;
